/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const LinkOut: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M8 5C8.55228 5 9 5.44772 9 6C8.99997 6.55226 8.55226 7 8 7H5V19H17V16C17 15.4477 17.4477 15 18 15C18.5523 15 19 15.4477 19 16V20C19 20.5523 18.5523 21 18 21H4C3.44774 21 3.00003 20.5523 3 20V6L3.00488 5.89746C3.05621 5.39333 3.48232 5 4 5H8ZM20.0879 3.01953C20.592 3.07089 20.9854 3.497 20.9854 4.01465V8.5C20.9853 9.05223 20.5376 9.49996 19.9854 9.5C19.4331 9.5 18.9854 9.05226 18.9854 8.5V6.42871L12.707 12.707C12.3165 13.0975 11.6835 13.0975 11.293 12.707C10.9025 12.3165 10.9025 11.6835 11.293 11.293L17.5713 5.01465H15.5C14.9477 5.01465 14.5 4.56693 14.5 4.01465C14.5 3.46236 14.9477 3.01465 15.5 3.01465H19.9854L20.0879 3.01953Z'
      fill='currentColor'
    />
  </React.Fragment>
)
